// useIsVisible hook. This hook returns true when the component it is
// referencing (the ref passed in) is visible.
//
// This is based on
// https://dev.to/bcncodeschool/detecting-if-an-element-is-in-view-with-react-5b60
//

import { useState, useEffect } from 'react';

function useIsVisible(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (ref && ref.current && typeof ref.current === 'object') {
      // Create an IntersectionObserver to observe the ref's visibility
      const observer = new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting),
      );

      // Start observing the element
      observer.observe(ref.current);

      // Cleanup the observer when the component unmounts or ref changes
      return () => {
        observer.disconnect();
      };
    }
  }, [ref]);

  return isIntersecting;
}

export default useIsVisible;
